// Entry de la busqueda: modulos en resources/js/searchbar/
import { initSearchAndScroll } from "./searchbar/busqueda";
import { modalSearchOutUser } from "./searchbar/historial";
import "./searchbar/modal-busqueda";
import "./searchbar/filtros-nav";

window.addEventListener('DOMContentLoaded', () => {
    initSearchAndScroll();
    modalSearchOutUser();
});
